import $ from "jquery";
import 'jquery.mmenu';

$(function() {

  var $menu = $("#mobile-navigation");

  if($menu.length > 0) {
    var $navbarBottom = $('#mobile-navigation-navbar-bottom');
    var $menu = $("#mobile-navigation").mmenu({
      //   options
      "extensions": [
        "pagedim-black",
        "position-right",
        "theme-dark",
        "position-front"
      ],
      "navbar": {
        "title": ""
      },
      "navbars": [{
          "position": "top",
          "content": '<button class="mmenu-button mmenu-close" type="button"><span class="icon-cross"></span></button>'
        }, {
          "position": "bottom",
          "content": $navbarBottom
          //"content": '<button id="mmenu-close" class="mobile-navigation-button hamburger hamburger--collapse is-active" type="button"><span class="hamburger-box"><span class="hamburger-inner"></span></span></button>'
        }
      ],
      "wrappers": ["bootstrap4"]
    }, {
      selectedClass: "active"
    });

    var API = $menu.data( "mmenu" );

    $(".mmenu-open").on( "click", function() {
      API.open();
    });

    $('.mmenu-close').on( "click", function() {
      API.close();
    });

    // WEBERTYPO3-305: Landingpages mmenu optimieren
    $('.nav > .nav-item > a.nav-link[href*="#"]').on( "click", function() {
      API.close();
    });
  }
});
